import React from 'react';

const getBlockImages = (image, images) => {
  return Array.isArray(images) && images.length > 0
    ? images
    : [image].filter(Boolean);
};

const getImageLayout = (imageCount, imageLayout) => {
  return imageLayout || (imageCount > 1 ? 'stack' : 'single');
};

const MediaTextBlock = ({
  className = '',
  image,
  images,
  imageLayout,
  imagePosition = 'start',
  textHtml,
  title,
}) => {
  const blockImages = getBlockImages(image, images);
  const imageCount = blockImages.length;
  const resolvedImageLayout = getImageLayout(imageCount, imageLayout);

  if (imageCount === 0 && !title && !textHtml) {
    return null;
  }

  const blockClassName = [
    'media-text-block',
    imagePosition === 'end' ? 'media-text-block--image-end' : '',
    imageCount > 1 ? 'media-text-block--image-stack' : '',
    imageCount > 0 ? `media-text-block--image-count-${imageCount}` : '',
    resolvedImageLayout ? `media-text-block--image-layout-${resolvedImageLayout}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={blockClassName}>
      {imageCount > 0 && (
        <div className="img media-text-block__media">
          {blockImages.map((blockImage, index) => (
            <img
              key={`media-text-block-image-${index}`}
              className={`media-text-block__image media-text-block__image--${index + 1}`}
              src={blockImage}
              alt=""
            />
          ))}
        </div>
      )}
      {(title || textHtml) && (
        <div className="text media-text-block__content">
          {title && <h2 className="media-text-block__title">{title}</h2>}
          {textHtml && (
            <p
              className="media-text-block__text"
              dangerouslySetInnerHTML={{ __html: textHtml }}
            ></p>
          )}
        </div>
      )}
    </div>
  );
};

export default MediaTextBlock;
